import service from "@/utils/request";

export function getWareInReceivePage(params) {
  const requestParams = {
    wareInStatus: params?.wareInStatus ?? 0,
    current: params?.current || 1,
    size: params?.size || 20,
  };

  if (
    params?.inType !== undefined &&
    params?.inType !== null &&
    params?.inType !== ""
  ) {
    requestParams.inType = params.inType;
  }

  if (
    params?.wareInType !== undefined &&
    params?.wareInType !== null &&
    params?.wareInType !== ""
  ) {
    requestParams.wareInType = params.wareInType;
  }

  if (
    params?.startTime !== undefined &&
    params?.startTime !== null &&
    params?.startTime !== ""
  ) {
    requestParams.startTime = params.startTime;
  }

  if (
    params?.endTime !== undefined &&
    params?.endTime !== null &&
    params?.endTime !== ""
  ) {
    requestParams.endTime = params.endTime;
  }

  if (
    params?.supplierId !== undefined &&
    params?.supplierId !== null &&
    params?.supplierId !== ""
  ) {
    requestParams.supplierId = params.supplierId;
  }

  // 单号搜索：receiptNo/wareInNo/materialNo（单个）
  if (
    params?.receiptNo !== undefined &&
    params?.receiptNo !== null &&
    params?.receiptNo !== ""
  ) {
    requestParams.receiptNo = params.receiptNo;
  }

  if (
    params?.wareInNo !== undefined &&
    params?.wareInNo !== null &&
    params?.wareInNo !== ""
  ) {
    requestParams.wareInNo = params.wareInNo;
  }

  if (
    params?.materialNo !== undefined &&
    params?.materialNo !== null &&
    params?.materialNo !== ""
  ) {
    requestParams.materialNo = params.materialNo;
  }

  // 批量单号搜索：多个编码用逗号分隔
  if (
    params?.receiptNos !== undefined &&
    params?.receiptNos !== null &&
    params?.receiptNos !== ""
  ) {
    requestParams.receiptNos = params.receiptNos;
  }

  if (
    params?.wareInNos !== undefined &&
    params?.wareInNos !== null &&
    params?.wareInNos !== ""
  ) {
    requestParams.wareInNos = params.wareInNos;
  }

  if (
    params?.materialNos !== undefined &&
    params?.materialNos !== null &&
    params?.materialNos !== ""
  ) {
    requestParams.materialNos = params.materialNos;
  }

  if (
    params?.sortField !== undefined &&
    params?.sortField !== null &&
    params?.sortField !== ""
  ) {
    requestParams.sortField = params.sortField;
  }

  return service.get("/uic-system_hf/warein/wareInPage", {
    params: {
      ...requestParams,
    },
  });
}

export function getWareInReceiveDetail(id) {
  return service.get("/uic-system/api_hf/warein/detail", {
    params: {
      id,
    },
  });
}

export function getWareInSupplierStockList(supplierId) {
  return service.get("/uic-system/api/warein/supplier/stock/list", {
    params: {
      supplierId,
    },
  });
}

export function getSupplierWare(supplierId) {
  return service.get("/api_hf/uic-system/ware/getSupplierWare", {
    params: {
      supplierId,
    },
  });
}

export function getWareInMaterialStockList(params) {
  return service.get("/uic-system/api_hf/warein/material/stock/list", {
    params: {
      materialId: params?.materialId,
      wareInId: params?.wareInId,
    },
  });
}

export function collectWareIn(data) {
  return service.post("/uic-system/api_hf/warein/collectPro", data);
}

export function collectProMulti(data) {
  return service.post("/uic-system/api_hf/warein/collectProMulti", data);
}

export function confirmWareInCollect(id) {
  return service.post("/uic-system/api_hf/warein/collect/confirm", {
    id,
  });
}

export function collectAndConfirm(data) {
  return service.post("/uic-system/api_hf/warein/collectAndConfirm", data);
}

export function distributeWareIn(ids) {
  return service.post(
    "/uic-system/warein/distribute",
    {},
    {
      params: {
        ids,
      },
    },
  );
}

export function removeWareIn(ids) {
  return service.post(
    "/uic-system/warein/remove",
    {},
    {
      params: {
        ids,
      },
    },
  );
}

export function redFlushByWare(data) {
  return service.post("/uic-system_hf/warein/redFlushByWare", data);
}

export function updateIsBad(id) {
  return service.post(
    "uic-system_hf/warein/wareout/updateIsBad",
    {},
    {
      params: {
        id,
      },
    },
  );
}

/**
 * 查询多版本物料的子版本列表
 * @param {string|number} id - 父物料 id
 */
export function getMaterialVersionList(id) {
  return service.get("/uic-system_hf/material/getVersionFlag", {
    params: { id },
  });
}

/**
 * 更新入库单物料子版本
 * @param {Object} params
 * @param {string|number} params.id - 入库单 id
 * @param {string|number} params.oldMaterialId - 多版本父物料 id
 * @param {string|number} params.newMaterialId - 选中的子物料 id
 */
export function updateWareInVersionFlag(params) {
  const id = params?.id;
  const oldMaterialId = params?.oldMaterialId;
  const newMaterialId = params?.newMaterialId;
  return service.post("/uic-system_hf/warein/updatevVersionFlag", null, {
    params: {
      id,
      oldMaterialId,
      newMaterialId,
    },
  });
}
